import { DIALECT_GROUPS } from "../../lib/constants";

export interface DialectPickerProps {
  value: readonly string[];
  onChange: (value: string[]) => void;
  disabled?: boolean;
}

/**
 * Multi-select chips for 方言背景. Students pick by place, not by linguistic
 * label, so every chip carries the region it covers.
 */
export function DialectPicker({ value, onChange, disabled }: DialectPickerProps) {
  const toggle = (id: string) => {
    onChange(value.includes(id) ? value.filter((v) => v !== id) : [...value, id]);
  };
  return (
    <div className="xz-chips" role="group" aria-label="方言背景">
      {DIALECT_GROUPS.map((d) => {
        const on = value.includes(d.id);
        return (
          <button
            key={d.id}
            type="button"
            className={`xz-chip${on ? " is-on" : ""}`}
            aria-pressed={on}
            disabled={disabled}
            onClick={() => toggle(d.id)}
          >
            <span className="xz-chip__label">{d.label}</span>
            <span className="xz-chip__hint">{d.hint}</span>
          </button>
        );
      })}
    </div>
  );
}
